(function() {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-about-history]'));

  roots.forEach(function(root) {
    if (root.dataset.manualCarouselReady === 'true') return;
    root.dataset.manualCarouselReady = 'true';

    var viewport = root.querySelector('[data-history-viewport]');
    var track = root.querySelector('[data-history-track]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-history-item]'));
    var descriptions = Array.prototype.slice.call(root.querySelectorAll('.firefly-about-history__description'));
    var previous = root.querySelector('[data-history-prev]');
    var next = root.querySelector('[data-history-next]');
    if (!viewport || !track || !items.length || !previous || !next) return;

    var activeIndex = 0;
    var ticking = false;
    var alignmentFrame = 0;

    /* 程序化滚动(箭头)期间抑制 scroll 事件的激活重算:
       末端几个条目的对齐位置会被钳到轨道最大滚动处,仅凭位置无法区分
       "翻到 2021"和"翻到最末条目",因此程序化滚动由 scrollToIndex 显式设置激活项,
       滚动同步只在用户手动滑动时生效 */
    var syncSuppressed = false;
    var syncTimer = 0;

    function suppressSync() {
      syncSuppressed = true;
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(function () {
        syncSuppressed = false;
      }, 160);
    }

    function alignDescriptions() {
      if (!descriptions.length) return;
      descriptions.forEach(function(description) {
        description.style.minHeight = '';
      });
      if (!window.matchMedia('(min-width: 768px)').matches) return;

      var maximumHeight = descriptions.reduce(function(maximum, description) {
        return Math.max(maximum, description.offsetHeight);
      }, 0);

      descriptions.forEach(function(description) {
        description.style.minHeight = maximumHeight + 'px';
      });
    }

    function scheduleDescriptionAlignment() {
      if (alignmentFrame) window.cancelAnimationFrame(alignmentFrame);
      alignmentFrame = window.requestAnimationFrame(function() {
        alignmentFrame = 0;
        alignDescriptions();
      });
    }

    function itemOffset(index) {
      return items[index].offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
    }

    function updateActive(index) {
      activeIndex = Math.max(0, Math.min(items.length - 1, index));
      items.forEach(function(item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === activeIndex);
      });
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === items.length - 1;
    }

    function nearestIndex() {
      /* 滚动到两端时钳制:左端激活第一项,右端激活最后一项,
         避免"左缘最近"算法在末端把高亮算到中间年份上 */
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (viewport.scrollLeft <= 1) return 0;
      if (viewport.scrollLeft >= maxScroll - 1) return items.length - 1;

      var viewportLeft = viewport.getBoundingClientRect().left + (parseFloat(getComputedStyle(track).paddingLeft) || 0);
      var closestIndex = 0;
      var closestDistance = Infinity;

      items.forEach(function(item, index) {
        var distance = Math.abs(item.getBoundingClientRect().left - viewportLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function scrollToIndex(index) {
      var targetIndex = Math.max(0, Math.min(items.length - 1, index));
      suppressSync();
      viewport.scrollTo({ left: itemOffset(targetIndex), behavior: 'smooth' });
      updateActive(targetIndex);
    }

    previous.addEventListener('click', function() {
      scrollToIndex(activeIndex - 1);
    });

    next.addEventListener('click', function() {
      scrollToIndex(activeIndex + 1);
    });

    viewport.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        ticking = false;
        if (syncSuppressed) {
          /* 程序化滚动仍在进行:续期抑制窗口,静默 160ms 后恢复手动同步 */
          window.clearTimeout(syncTimer);
          syncTimer = window.setTimeout(function() {
            syncSuppressed = false;
          }, 160);
          return;
        }
        updateActive(nearestIndex());
      });
    }, { passive: true });

    window.addEventListener('resize', scheduleDescriptionAlignment);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleDescriptionAlignment);
    }
    window.addEventListener('load', scheduleDescriptionAlignment, { once: true });

    alignDescriptions();
    viewport.scrollLeft = 0;
    updateActive(0);
  });
})();
